import React, { Component } from 'react';
import { object } from 'prop-types';
import { Spinner} from "../components";

class Login extends Component {
  static propTypes = {
    auth: object.isRequired,
  };

  componentDidMount() {
    this.props.auth.login();
  }

  render() {
    return (
     <Spinner/>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/login/Login.jsx